import { useIsDesktop } from "../../hooks/useIsDesktop";
import HeaderComponent from "../Header/HeaderComponent";
import HeaderDesktop from "../Header/HeaderDesktop";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./style.module.css";
import { useMemo, useState } from "react";
import { AllInvoice } from "./AllInvoice";
import { AllPayment } from "./AllPayment";
import { OutlineTabs } from "../../components/tabs/OutlineTabs";
import { useSearchInstallment } from "../../hooks/fetch-data/useSearchInstallment.js";
import { useUser } from "../../hooks/useUser";

export const MyLoanInvoice = () => {
  const navigate = useNavigate();
  const { loanId } = useParams();
  const { t } = useTranslation("myLoanInvoice");
  const { userData } = useUser();
  const { data: userLoanInfo } = useSearchInstallment(userData?.id);
  const [currentTab, setCurrentTab] = useState(0);
  const loan = useMemo(() => {
    return userLoanInfo?.loan_data?.find((l) => l.loan_id === parseInt(loanId));
  }, [userLoanInfo?.loan_data, loanId]);
  const tabs = useMemo(() => {
    return [
      {
        title: t("allPayment"),
        content: <AllPayment loan={loan} />,
      },
      {
        title: t("allInvoice"),
        content: <AllInvoice loan={loan} />,
      },
    ];
  }, [t, loan]);
  const isDesktop = useIsDesktop();

  return (
    <div className={styles.pageWrapper}>
      {isDesktop ? (
        <HeaderDesktop title={t("header")} showIcon={true} onBack={true} />
      ) : (
        <HeaderComponent
          title={t("header")}
          onBack={() => {
            navigate(`/my-loans/${loanId}`);
          }}
        />
      )}
      <div className={styles.content}>
        {t("loanNumber")} {loan?.loan_name}
      </div>
      {tabs.length > 0 && (
        <OutlineTabs
          tabs={tabs}
          currentTab={currentTab}
          tabSetter={setCurrentTab}
        />
      )}
    </div>
  );
};
